import apiNews from '@/api/news'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createNewsStart: '[create news] create news start',
  createNewsSuccess: '[create news] create news success',
  createNewsFailure: '[create news] create news failure',
}

export const actionTypes = {
  createNews: '[create news] create news',
}

const mutations = {
  [mutationTypes.createNewsStart](state) {
    state.isLoading = true
    state.news = null
  },

  [mutationTypes.createNewsSuccess](state, payload) {
    state.news = payload
    state.isLoading = false
  },

  [mutationTypes.createNewsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.createNews](context, newsInput) {
    context.commit(mutationTypes.createNewsStart)
    return new Promise((resolve) => {
      apiNews
        .createNews(newsInput)
        .then((response) => {
          context.commit(mutationTypes.createNewsSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createNewsFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
